/* マルジュ（アフィリエイト）CV計測用 */
const initMaruge = () => {
  const doc = (document as any);
  const jsTag = doc.createElement('script');
  jsTag.type = 'text/javascript';
  jsTag.id = 'c5e3c193y273353e';
  jsTag.src = 'https://af-wamazing.catsys.jp/ac/action_js.php';
  jsTag.charset = 'UTF-8';
  doc.body.appendChild(jsTag);
};

/* 幹事割マルジュ（アフィリエイト）CV計測用 */
const initKanjiwariMaruge = () => {
  const doc = (document as any);
  const jsTag = doc.createElement('script');
  jsTag.innerHTML = `
    (() => {
      const uqid = 'c5e3c193y273353e';
      const cid = '127';
      const a = document.createElement('script');
      a.dataset.uqid = uqid;
      a.dataset.cid = cid;
      a.id = 'afadfpc-' + uqid + 'cid' + cid + '-' + Date.now();
      a.src = '//af-wamazing.catsys.jp/fpc/cookie_js.php?scriptId=' + encodeURIComponent(a.id);
      document.head.appendChild(a);
    })();
  `
  jsTag.charset = 'UTF-8';
  doc.body.appendChild(jsTag);
};

/*
  成果通知タグ
  gidは管理画面の広告管理 > 成果通知タグ > 下記のタグから取得
  - 遷移先設置タグ（グループ単位）
  - 成果タグ:1stパーティ計測（グループ単位）
*/
const marugeTrackItemPurchased = (amount: number, uid1: string, uid2: string) => {
  console.log('Maruge Track Item Purchased');
  console.log(`Maruge amount: ${amount} uid1: ${uid1} uid2: ${uid2}`);
  const doc = (document as any);
  const jsTag = doc.createElement('script');
  jsTag.innerHTML = `
    (() => {
      const uqid = 'c5e3c193y273353e';
      const gid = '1';
      const af = '';
      const pid = 1;
      const a = document.createElement('script');
      a.src = '//af-wamazing.catsys.jp/ac/action_js.php';
      a.id = 'afadaction-' + Date.now();
      a.addEventListener('load', () => { 
        try {
          (new fpcAction(a.id)).groupAction(gid, af, ["${uid1}", "${uid2}"], pid, "${amount}", uqid);
          console.log('Maruge tracking script loaded and executed successfully');
        } catch (error) {
          console.error('Error executing Maruge tracking:', error);
        }
      });
      document.head.appendChild(a);
    })();
  `;
  jsTag.charset = 'UTF-8';
  doc.body.appendChild(jsTag);
  console.log('Maruge Track Item Purchased finished');
};

export { initMaruge, marugeTrackItemPurchased, initKanjiwariMaruge }
